import axios from 'axios';
import { getClerkSessionToken } from '@/services/clerk';

const apiUrl = process.env.VUE_APP_NODE_ENV === 'production'
  ? process.env.VUE_APP_PROD_API_URL
  : process.env.VUE_APP_DEV_API_URL;

const exchangeRatesApi = axios.create({
  baseURL: `${apiUrl.replace(/\/$/, '')}/api`,
  headers: { 'Content-Type': 'application/json' },
});

export async function fetchExchangeRates() {
  const sessionToken = await getClerkSessionToken();

  if (!sessionToken) {
    throw new Error('You must be signed in to fetch exchange rates.');
  }

  const response = await exchangeRatesApi.get('/exchange-rates', {
    headers: { Authorization: `Bearer ${sessionToken}` },
  });

  return response.data;
}
